import {AsyncRequestTypeName} from 'interfaces';

export enum InteractiveChatAction {
    SendMessage = 'send-message',
    Tree = 'tree',
    Back = 'back',
    CallAgent = 'call-agent',
    CallAgentConfirm = 'call-agent-confirm',
    Reassign = 'reassign',
    InteractiveChat = 'interactive-chat',
    ChatGpt = 'chat-gpt',
    Claude = 'claude',
    Mastra = 'mastra',
    Watsonx = 'watsonx',
    InternalLiveAgent = 'internal-live-agent',
    AsyncRequest = 'async-request',
    RequestAppointment = 'request-appointment',
}

export type InteractiveChatItem = {
    name?: string;
    text: string;
    action: InteractiveChatAction;
    replyMessage?: string;
    actionData?: {
        agentEmail?: string;
        interactiveChatId?: string;
        assignment?: {
            groupId: string;
            subgroupId?: string;
        };
        asyncRequest?: {
            typeName: AsyncRequestTypeName;
            condition?: string;
        }
    }
}

export type NodePath = number[];